import accessibleSubmitButton from './accessible-submit-button';
import contactFormAppends from './contact-form-appends';
import sendTestForm from './send-test-form';
import contactFormsLazyLoad from './contact-forms-lazy-load';
import aiEnhancedForm from './ai-enhanced-form';
import nfQueryStringMergeTags from './nf-querystring-merge-tags';

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	if (window.siteFeatureToggles && parseInt(siteFeatureToggles.ENABLE_AI_ENHANCED_FORM, 10)) {
		aiEnhancedForm();
	}

	accessibleSubmitButton();

	contactFormAppends();

	sendTestForm();

	contactFormsLazyLoad();

	// Pull the function call out from 'if' when
	// the 'ENABLE_NF_QUERYSTRING_MERGE_TAGS' toggle is removed.
	if (window.flNfQueryStringMergeTags) {
		nfQueryStringMergeTags();
	}
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/index.js